import { render, staticRenderFns } from "./SectionsView.vue?vue&type=template&id=69ea3032"
import script from "./SectionsView.vue?vue&type=script&lang=js"
export * from "./SectionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports